"use client";
import { useContext } from "react";
import { EvidenceFilterContext } from "./evidenceFilter.context";

// The page-wide evidence filter set by the filter bar.
export function useEvidenceFilter() {
  return useContext(EvidenceFilterContext);
}
